const requiredPressCount = 5;
const pressWindowMilliseconds = 2000;
const initializationFlag = '__asportReloadShortcutInitialized';

const isEditableTarget = target => target instanceof HTMLElement &&
	(target.isContentEditable || ['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName));

// Enables the hidden local-development opt-in without interfering with normal text entry.
export const initReloadShortcut = () => {
	if (window[initializationFlag]) return;
	window[initializationFlag] = true;

	let pressTimestamps = [];

	document.addEventListener('keydown', event => {
		if (event.repeat || event.ctrlKey || event.metaKey || event.altKey || isEditableTarget(event.target)) {
			return;
		}

		if (event.key.toLowerCase() !== 'r') {
			pressTimestamps = [];
			return;
		}

		const currentTimestamp = Date.now();
		pressTimestamps = pressTimestamps.filter(timestamp => currentTimestamp - timestamp < pressWindowMilliseconds);
		pressTimestamps.push(currentTimestamp);

		if (pressTimestamps.length < requiredPressCount) return;

		const url = new URL(window.location.href);
		url.searchParams.set('reload', 'on');
		window.history.replaceState(window.history.state, '', url.toString());
		window.location.reload();
	});
};
